import { useMemo } from "react"
import { UserModuleType } from "@tm/models"
import { useUser } from "../user"

export function useOwnListsCompilationsParameters() {
    const { userContext } = useUser()

    return useMemo(() => {
        const ownListsCompilationsModule = userContext.modules?.find((x) => x.type === UserModuleType.OwnListsCompilations)
        return {
            hasOwnListsCompilationsModule: !!ownListsCompilationsModule,
            hasMyArticles: !!ownListsCompilationsModule?.parameters?.find((x) => x.key === "MyArticles"),
            hasMyWorks: !!ownListsCompilationsModule?.parameters?.find((x) => x.key === "MyWorkValues"),
            hasFavoriteArticles: !!ownListsCompilationsModule?.parameters?.find((x) => x.key === "FavouriteArticles"),
        }
    }, [userContext])
}
